module.exports = __webpack_public_path__ + "img/CheeseTray.e25fe538.png";